import { useState } from "react";
import { ChevronDown } from "lucide-react";

// Collapsible block for phone layouts. Children stay mounted (state survives collapse).
export function MobileSection({ step, title, summary, defaultOpen = true, children, testId }) {
  const [open, setOpen] = useState(defaultOpen);
  return (
    <section className="card-base overflow-hidden" data-testid={testId}>
      <button
        type="button"
        onClick={() => setOpen((v) => !v)}
        aria-expanded={open}
        className="w-full flex items-center gap-3 px-4 py-3.5 text-left"
        data-testid={testId ? `${testId}-toggle` : undefined}
      >
        {step && (
          <span className="w-7 h-7 shrink-0 grid place-items-center bg-kolt-slate-dark text-white font-mono text-[11px] font-bold">
            {step}
          </span>
        )}
        <span className="flex-1 min-w-0">
          <span className="block font-display font-bold text-[15px] text-kolt-slate-dark leading-tight">{title}</span>
          {summary && !open && (
            <span className="block text-xs text-slate-500 truncate mt-0.5">{summary}</span>
          )}
        </span>
        <ChevronDown className={`w-5 h-5 text-slate-400 transition-transform duration-200 ${open ? "rotate-180" : ""}`} />
      </button>
      <div className={open ? "px-4 pb-4" : "hidden"}>{children}</div>
    </section>
  );
}

// Fixed bar pinned above the bottom nav — price on the left, action on the right.
export function MobileStickyBar({ children, testId, flush = false }) {
  return (
    <div
      className={`fixed inset-x-0 ${flush ? "bottom-0 pb-[env(safe-area-inset-bottom)]" : "bottom-16"} z-40 bg-white border-t border-slate-200 shadow-[0_-8px_24px_rgba(31,40,48,0.08)] px-3 py-2.5`}
      data-testid={testId}
    >
      <div className="flex items-center gap-3">{children}</div>
    </div>
  );
}
